import { Injectable } from '@angular/core';

@Injectable()
export class ModulesService {

  constructor() { }

  get() {
    return [
      { id: 0, path: 'login' },
      { id: 1, path: 'movimientos-obra-proyecciones' },
      { id: 2, path: 'catalogo-obras' },
      { id: 3, path: 'catalogo-cuentas' },
      { id: 4, path: 'catalogo-conceptos' },
      { id: 5, path: 'catalogo-proveedores' },
      { id: 6, path: 'catalogo-inversionistas'},
      { id: 7, path: 'catalogo-reportes'},
      { id: 8, path: 'liquidacion-captura'},
      { id: 9, path: 'liquidacion-revision'},
      { id: 10, path: 'usuarios' },
      { id: 11, path: 'contratos' },
      { id: 12, path: 'gastos' },
      { id: 13, path: 'catalogo-reportes' },
      { id: 14, path: 'contratos/convenios' },
      { id: 15, path: 'catalogo-productos' },
      { id: 16, path: 'ventas' },
      { id: 17, path: 'catalogo-reportes/reporte-cuentas-por-cobrar' },
      { id: 18, path: 'catalogo-reportes/reporte-cuentas-por-pagar' }
    ]
  }

  find(id) {
    return this.get().find(p => {
      const equals = (p.id == id);
      return equals;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/tools/modules.service.ts